import { ProductNearByDTO } from 'app/model/products/product-nearby-dto.model';
import { SearchFormModel } from 'app/model/search-form-model';

export class ProductPOIPayload {
    langId: String;
    currencyId: Number;
    categoryId: Number;
    destinationId: Number;
    poi: PoiLocation;
    filter: FilterPoi;
    companyId: number;

    constructor(productNearBy: ProductNearByDTO = undefined, searchFormModel: SearchFormModel = undefined) {
        if (productNearBy) {
            this.langId = productNearBy.langId;
            this.categoryId = 3;
            this.currencyId = 1;
            this.destinationId = productNearBy.destinationId;
            this.poi = new PoiLocation(searchFormModel);
            this.filter = new FilterPoi(productNearBy, searchFormModel);
        }
    }
}

export class FilterPoi {
    distance: Number;
    priceRange: PriceRange;
    checkIn: String;
    checkOut: String;
    rooms: Room[];
    sort: SortBy;
    pagination: Paginate;

    constructor(productNearBy: ProductNearByDTO = undefined, searchFormModel: SearchFormModel = undefined) {
        if (productNearBy) {
            this.distance = searchFormModel.radius;
            this.priceRange = productNearBy.priceRange;
            this.checkIn = productNearBy.checkIn;
            this.checkOut = productNearBy.checkOut;
            this.rooms = productNearBy.rooms;
            this.sort = new SortBy;
            this.pagination = new Paginate;
        }
    }
}

export class PriceRange {
    min: Number;
    max: Number;
    constructor(min: Number = undefined, max: Number = undefined) {
        this.min = min;
        this.max = max;
    }
}

export class Room {
    adult: Number;
    children: Number[];
}

export class Paginate {
    itemperpage: Number;
    pageno: Number;
    constructor() {
        this.itemperpage = 30;
        this.pageno = 1;
    }

}

export class SortBy {
    poiMap: Boolean;
    constructor() {
        this.poiMap = true;
    }
}

export class PoiLocation {
    lat: number;
    lon: number;
    constructor( searchFormModel: SearchFormModel = undefined) {
        this.lat = searchFormModel.destination.poi.lat;
        this.lon = searchFormModel.destination.poi.lon;
    }
  }


// WEBPACK FOOTER //
// ./src/app/services/products/payload/product-poi-payload.ts